import styled, { css } from 'styled-components';

// Import styles
import { flex, spin, spinReverse } from 'components/styles';

type LoaderItemProps = {
	width: number;
	height: number;
};

type LoaderWrapperProps = {
	position: string;
	top: number;
	wrapperHeight: string;
	zIndex: number;
	background: boolean;
};

const Loader = ({ width = 15, height = 15, position = 'fixed', background = true, zIndex = 1200, wrapperHeight = '100%', top = 0 }) => (
	<LoaderWrapper zIndex={zIndex} background={background} position={position} wrapperHeight={wrapperHeight} top={top} data-testid="loader">
		<LoaderItem width={width} height={height} />
	</LoaderWrapper>
);

const base = css<LoaderItemProps>`
	border: ${({ width }) => width / 5}px solid transparent;
	border-radius: 50%;
`;

const LoaderWrapper = styled.div<LoaderWrapperProps>`
	position: ${({ position }) => position};
	top: ${({ top }) => top};
	left: 0;
	width: 100%;
	height: ${({ wrapperHeight }) => wrapperHeight};
	z-index: ${({ zIndex }) => zIndex};
	transition: opacity 0.4s ease-in-out;
	background-color: ${({ background }) => (background ? ({ theme }) => theme.loaderBg : 'transparent')};
	${flex()}
`;
const LoaderItem = styled.div<LoaderItemProps>`
	display: block;
	width: ${({ width }) => width}rem;
	height: ${({ height }) => height}rem;
	position: relative;
	animation: ${spin} 1.7s linear infinite;
	${base};
	border-top-color: ${({ theme }) => theme.palette.primary.main};

	&:before {
		content: '';
		display: inline-block;
		position: absolute;
		top: 5px;
		left: 5px;
		right: 5px;
		bottom: 5px;
		${base}
		border-top-color:${({ theme }) => theme.palette.primary.dark};
		animation: ${spinReverse} 0.6s linear infinite;
	}
	&:after {
		content: '';
		display: inline-block;
		position: absolute;
		top: 15px;
		left: 15px;
		right: 15px;
		bottom: 15px;
		${base}
		border-top-color:${({ theme }) => theme.palette.primary.light};
		animation: ${spin} 1s linear infinite;
	}
`;

export default Loader;
